import TourButton from './TourButton.jsx'

/**
 * Top navigation bar — mirrors q2-goals.html line 313-318.
 * Sticky at the top; cross-links to the Q2 Pipeline & Targets dashboard.
 * Includes the Tour launcher on the right so anyone can re-run the
 * guided walkthrough on demand.
 */
export default function TopNav() {
  return (
    <nav className="top-nav">
      <span className="brand">Common Trust</span>
      <span className="sep">·</span>
      <a
        href="https://www.dashboards.common-trust.com/hubspot-dashboard.html"
        target="_self"
      >
        📊 Q2 Pipeline &amp; Targets
      </a>
      <a href="#" className="active">🎯 Q2 Goals</a>
      <span style={{ marginLeft: 'auto' }}>
        <TourButton />
      </span>
    </nav>
  )
}
